module.exports = __webpack_public_path__ + "img/26.18ddc280.jpg";